import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useDispatch, useSelector } from 'react-redux';
import { setDefaultSettings } from 'app/store/fuse/settingsSlice';
import _ from '@lodash';
import { navbarToggleMobile, navbarToggle } from '../../store/fuse/navbarSlice';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useState } from 'react';

function NavbarToggleButton(props) {
  const dispatch = useDispatch();
  const theme = useTheme();
  const [activo, setActivo] = useState(true);
  const mdDown = useMediaQuery(theme.breakpoints.down('lg'));
  const settings = useSelector(({ fuse }) => fuse.settings.current);
  const { config } = settings.layout;

  return (
    <IconButton
      className={`${props.className} additional-toggle`}
      color="inherit"
      size="small"
      onClick={(ev) => {
        if (mdDown) {
          setActivo(true);
          dispatch(navbarToggleMobile());
        } else if (config.navbar.style === 'style-2') {
          dispatch(
            setDefaultSettings(
              _.set({}, 'layout.config.navbar.folded', !settings.layout.config.navbar.folded)
            )
          );
        } else {
          setActivo(true);
          dispatch(navbarToggle());
        }
      }}
    >
      {activo ? (
        <img
          className="w-20 flex cross-icon-img justify-end"
          src="assets/images/logos/menu_ico.png"
          style={{ borderRadius: '100%' }}
        />
      ) : (
        <img
          className="w-20 flex hamburger-icon-img justify-end"
          src="assets/images/icons/burger-bar.png"
          style={{ borderRadius: '100%' }}
        />
      )}

      {/* {console.log(props)}
      {props.children}
      {props.pather} */}
    </IconButton>
  );
}

// NavbarToggleButton.defaultProps = {
//   children: (
//     // burger-bar
//     <div style={{ justifyContent: "flex-end" }}>
//       <img className="w-20 flex  justify-end" src="assets/images/logos/menu_ico.png" style={{ borderRadius: "100%" }} />
//     </div>
//   ),
//   pather: (
//     // burger-bar
//     <div style={{ justifyContent: "flex-end" }}>
//       <img className="w-20 flex  justify-end" src="assets/images/icons/burger-bar.png" style={{ borderRadius: "100%" }} />
//     </div>
//   )
// };

export default NavbarToggleButton;
